<div *ngIf="data.action == 'Submit Hot Call' || data.action == 'Save Profile'  || data.action == 'Cancel Hot Call Message' || data.action == 'Update Runout'" class="hcm-dialog">
  <div class="d-flex flex-column align-items-center my-md-2 mx-2 px-1 my-2 gap-md-1">
    <img src="../../../../../assets/img/success.svg" class="moderate-image" alt="Check Circle">
    <span class="hcm-dialog-message text-center py-2 px-3">{{ data.message }}</span>
    <button class="hcm-black-btn" (click)="onSubmitHotCall()">
      {{'dialog.buttons.OK' |translate}}
    </button>
  </div>
  <div class="hcm-dialog-close">
    <img src="../../../../../assets/img/close.svg" class="smaller-icon" alt="close icon" (click)="onNo()">
  </div>
</div>
<div *ngIf="data.action == 'Inventory Error' || data.action == 'Cancel Hot Call' || data.action == 'Scan Owk'"
  class="hcm-dialog">
  <div class="d-flex flex-column">
    <span class="hcm-dialog-title pt-3 px-3 align-items-center d-flex flex-nowrap">
      <img *ngIf="data.action != 'Cancel Hot Call'" src="../../../../../assets/img/alert-icon.png" class="p-2"
        alt="HCM Alert">{{ data.title }}
    </span>
    <hr>
    <p class="hcm-dialog-message mb-md-2 mb-1 px-3">{{ data.message }}</p>
    <div class="d-flex justify-content-end pt-md-4 px-md-4 py-md-4 py-2 gap-md-3 gap-2 px-2">
      <button *ngIf="data.action != 'Scan Owk'" class="hcm-blue-btn" (click)="onNo()">
        {{ 'dialog.buttons.NO' | translate }}
      </button>
      <button *ngIf="data.action != 'Scan Owk'" class="hcm-black-btn" (click)="onYes()">
        {{ 'dialog.buttons.YES' | translate }}
      </button>
      <button *ngIf="data.action == 'Scan Owk'" class="hcm-black-btn" (click)="onNo()">
        {{ 'dialog.buttons.OK' | translate }}
      </button>
    </div>
  </div>
  <div class="hcm-dialog-close">
    <img src="../../../../../assets/img/close.svg" class="smaller-icon" alt="close icon" (click)="onNo()">
  </div>
</div>